// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { folder16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-folder': IconFolder;
    }
}

/**
 * The icon component for the 'folder' icon
 */
export class IconFolder extends Icon {
    public constructor() {
        super(folder16X16);
    }
}

registerIcon('icon-folder', IconFolder);
export const iconFolderTag = 'nimble-icon-folder';
